<template>
	<div id="myModal" class="modal text-white" tabindex="-1">
		<div class="modal-dialog ">
			<div class="modal-content bg-dark">
			<div class="modal-header">
				<h5 class="">Send Enquiry to Artist</h5>
				<button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close"></button>
			</div>
			<div class="modal-body">
				
				<div class="alert alert-success"  v-if="success">Enquiry has been sent successfully</div>
			<!-- content -->
			<form id="portfolio-form">
				<div class="mb-3">
					<label class="form-label">Full Name</label>
					<input class="form-control" type="text" name="full_name" v-model="full_name">
				</div>
				<div class="mb-3">
					<label class="form-label">Email</label>
					<input class="form-control" type="text" name="email" v-model="email">
				</div>
				<div class="mb-3">
					<label class="form-label">Phone Number</label>
					<input class="form-control" type="text" name="phone_number" v-model="phone_number">
				</div>
				<div class="mb-3">
					<label class="form-label">Details</label>
					<textarea class="h-24 form-control" type="text" name="details" v-model="details"></textarea>
				</div>
			</form>
			</div>
			<div class="modal-footer">
				<button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
				<button class="btn btn-primary text-white" @click="sendEnquiry($event)">Send</button>
			</div>
			</div>
		</div>
	</div>


</template>

<script>
const axios = require('axios');
export default {
    name:'portfolioenquiry',
    props:['laravelUrl', 'portfolioId'],
    data: function() {
        return{
			full_name: '',
			email: '',
			phone_number: '',
			details: '',
			success: false
        }
    },

    methods: {
		
        sendEnquiry(e) {
			e.preventDefault()
			const vm = this;
            axios.post(this.laravelUrl + '/api/portfolio/enquiry',{
                full_name:this.full_name,
                email: this.email,
                phone_number: this.phone_number,
                details: this.details,
                portfolio_id: Number(this.portfolioId)
            })
            .then(function (response) {
            	vm.success = true;
            });

        }
    },

}
</script>